/* eslint-disable react/display-name,react/prop-types */
import React from "react"
import withWidgetData from "./withWidgetData"
import { WidgetType } from "./widgetTypes"
// eslint-disable-next-line import/no-cycle
import templateRegistry from "./TemplateManager"

function withTemplate(Component) {
  return (props) => {
    const { name, reqOpt } = props
    if (name) {
      const template = templateRegistry.get(name)
      const { component: Template, defaultProps } = template
      // FIXME SR: ugly stuff here...
      //  > merge props bodyOpt
      const bodyOpt = { ...reqOpt.bodyOpt, ...defaultProps }
      const mergedReqOpt = { ...reqOpt, bodyOpt }
      return (
        <Component {...props} {...defaultProps} reqOpt={mergedReqOpt}>
          {(fwdProps) => <Template name={name} {...fwdProps} />}
        </Component>
      )
    }
    return <Component {...props} />
  }
}

/**
 * A template widget is basically a widget that process backend data with specific UI component develop in webportal,
 * compared to others component that display UI component based on server side layout configuration.
 * @param props
 * @returns {*}
 * @constructor
 */
function TemplateWidget(props) {
  const { data, children } = props
  return children(data)
}

TemplateWidget.propTypes = WidgetType.isRequired

export default withTemplate(withWidgetData(TemplateWidget))
